import { useOktaAuth } from "@okta/okta-react";
import { useMemo } from "react";

import { PermissionSet, createPermissionSet, extractRawPermissions } from "./authorizationService";

export const usePermissions = (): PermissionSet => {
  const { authState } = useOktaAuth();
  const token = authState?.accessToken?.accessToken ?? null;

  return useMemo(() => {
    const tokens = extractRawPermissions(token);
    return createPermissionSet(tokens);
  }, [token]);
};
